import React, { useState, useEffect, useContext } from "react";
import Lottie from 'react-lottie';
import { useNavigate, useSearchParams } from "react-router-dom";
import { postEditUserDataInfluencer, putEditUserDataCompany } from "../../api/myAccountApi";
import { UserContext } from "../../context/userContext";
import * as animationData from './paypal-logo-effect.json';
import { PaypalContainer } from "./PaypalStyled";
import Alert from "../../components/Alert/Alert";
import { FormattedMessage } from 'react-intl';

export default function Paypal() {

    const navigate = useNavigate();

    const [isStopped, setIsStopped] = useState(false);
    const [isPaused, setIsPaused] = useState(false);

    const { userType, userToken, setPayment } = useContext(UserContext);


    let [searchParams] = useSearchParams();
    const [showAlertError, setShowAlertError] = useState(false);

    const body = {
        attributes: {
            paypal: true
        }
    }

    useEffect(() => {

        const origin = sessionStorage.getItem('paypalLoginOrigin');

        if (searchParams.get('succes') === 'S' && userToken !== null) {
            if (userType === 'influencer') {
                postEditUserDataInfluencer({ body, token: userToken }).then((response) => {
                    if (response.status === 201) {
                        setPayment(true)
                        if (origin === 'cart') {
                            sessionStorage.removeItem('paypalLoginOrigin')
                            navigate('/mycart')
                        } else {
                            sessionStorage.removeItem('paypalLoginOrigin')
                            navigate('/myaccount')
                        }

                    }
                })
            } else if (userType === 'company') {
                putEditUserDataCompany({ body, token: userToken }).then((response) => {
                    if (response.status === 201) {
                        setPayment(true);
                        if (origin === 'cart') {
                            sessionStorage.removeItem('paypalLoginOrigin')
                            navigate('/mycart')
                        } else {
                            sessionStorage.removeItem('paypalLoginOrigin')
                            navigate('/myaccount')
                        }
                    }
                })
            }
        }

        if (searchParams.get('succes') === 'N' && userToken !== null) {
            setShowAlertError(true);
        }

    }, [searchParams, userToken])


    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return (
        <PaypalContainer>

            <Lottie options={defaultOptions}
                height={200}
                width={200}
                isStopped={isStopped}
                isPaused={isPaused} />

            {(showAlertError) && (<Alert
                title={<FormattedMessage id="alert_forward_title_2" defaultMessage="¡Error!" />}
                text={<FormattedMessage id="alert_error_paypal" defaultMessage="Ha ocurrido un  error, no pudimos conectar tu cuenta de paypal. Por favor intenta mas tarde." />}
                confirmText={<FormattedMessage id="alert_send_product_button" defaultMessage="¡Entendido!" />}
                onConfirm={() => {
                    if (origin === 'cart') {
                        sessionStorage.removeItem('paypalLoginOrigin')
                        navigate('/mycart')
                    } else {
                        sessionStorage.removeItem('paypalLoginOrigin')
                        navigate('/myaccount')
                    }
                }}
                setShowAlert={setShowAlertError} />)}
        </PaypalContainer>

    )
}